/* ============================================
   Don Chacho — Producto v2 JS
   Archivo: assets/dc-producto-v2.js
   ============================================ */
(function(){
  'use strict';

  /* ---- Tabs ---- */
  function initTabs() {
    document.querySelectorAll('.dc-prd__tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = tab.getAttribute('data-tab');
        document.querySelectorAll('.dc-prd__tab').forEach(function(t){ t.classList.remove('active'); });
        document.querySelectorAll('.dc-prd__tab-panel').forEach(function(p){ p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.querySelector('.dc-prd__tab-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ---- Thumbnails ---- */
  function initThumbs() {
    var mainImg = document.querySelector('.dc-prd__hero-img img');
    document.querySelectorAll('.dc-prd__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.getAttribute('data-src');
        if (mainImg && src) mainImg.src = src;
        document.querySelectorAll('.dc-prd__thumb').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ---- Selector de variante ---- */
  function initVariantes() {
    document.querySelectorAll('.dc-prd__var-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.dc-prd__var-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var variantId = btn.getAttribute('data-variant-id');
        var precio = btn.getAttribute('data-precio');
        var peso = btn.getAttribute('data-peso');
        if (variantId) document.querySelector('#dc-prd-variant-id').value = variantId;
        if (precio) document.querySelector('.dc-prd__precio').textContent = precio;
        if (peso) document.querySelector('.dc-prd__precio-unit').textContent = 'MXN · ' + peso;
      });
    });
  }

  /* ---- Cantidad ---- */
  function initQty() {
    var numEl = document.querySelector('.dc-prd__qty-num');
    if (!numEl) return;
    document.querySelector('.dc-prd__qty-btn--minus')?.addEventListener('click', function() {
      var v = parseInt(numEl.textContent);
      if (v > 1) numEl.textContent = v - 1;
    });
    document.querySelector('.dc-prd__qty-btn--plus')?.addEventListener('click', function() {
      numEl.textContent = parseInt(numEl.textContent) + 1;
    });
  }

  /* ---- Add to cart ---- */
  function initAddToCart() {
    var btn = document.querySelector('.dc-prd__cta');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var variantId = document.querySelector('#dc-prd-variant-id')?.value;
      var qty = parseInt(document.querySelector('.dc-prd__qty-num')?.textContent || '1');
      if (!variantId) return;
      var orig = btn.textContent;
      btn.textContent = 'Agregando...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r){ return r.json(); })
      .then(function() {
        btn.textContent = '✓ Agregado';
        btn.classList.add('added');
        showToast('✓ Agregado al carrito');
        updateCartCount();
        setTimeout(function() {
          btn.textContent = orig;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() { btn.textContent = orig; btn.disabled = false; });
    });
  }

  /* ---- Kit CTA ---- */
  function initKitCta() {
    var btn = document.querySelector('.dc-prd__cta-kit');
    if (!btn) return;
    btn.addEventListener('click', function() {
      window.location.href = '/pages/comprar#sec-personalizar';
    });
  }

  /* ---- Toast ---- */
  function showToast(msg) {
    var t = document.querySelector('.dc-prd__toast');
    if (!t) { t = document.createElement('div'); t.className = 'dc-prd__toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('visible');
    setTimeout(function(){ t.classList.remove('visible'); }, 2500);
  }

  /* ---- Cart count ---- */
  function updateCartCount() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initTabs();
    initThumbs();
    initVariantes();
    initQty();
    initAddToCart();
    initKitCta();
  });
})();